import { FullBox, Spinner } from 'seagull';
import { AccountingSyncIcon } from "../../integrations/Accounting/AccountingIcon/AccountingSyncIcon";
import styles from "./QBOButton.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function QBOButton(_ref) {
  let {
    children,
    hideIcon,
    loading,
    onClick,
    testId
  } = _ref;
  return /*#__PURE__*/_jsxs("button", {
    className: styles.root,
    onClick: onClick,
    disabled: loading,
    "data-testid": testId,
    children: [!hideIcon && /*#__PURE__*/_jsx(AccountingSyncIcon, {
      prefix: "qbo"
    }), children, loading && /*#__PURE__*/_jsx(FullBox, {
      centered: true,
      className: styles.loading,
      testId: testId && "".concat(testId, "-loading"),
      children: /*#__PURE__*/_jsx(Spinner, {
        size: 32
      })
    })]
  });
}